'use client'

import * as React from 'react'

import type { DesktopOs } from './links'

/**
 * Detects the visitor's desktop OS from the user agent. Defaults to `mac`
 * until the effect runs on the client (SSR cannot know the OS); components
 * render a stable default during hydration and update once mounted.
 */
export function useDetectedOs(): DesktopOs {
  const [os, setOs] = React.useState<DesktopOs>('mac')

  React.useEffect(() => {
    const ua = navigator.userAgent.toLowerCase()
    const isWindows = ua.includes('win')
    const isMac = ua.includes('mac') || ua.includes('iphone') || ua.includes('ipad')
    setOs(isWindows && !isMac ? 'windows' : 'mac')
  }, [])

  return os
}
